export enum IdentityDuplicateReviewStatusEnum {
  OPEN = "open",
  CLEARED = "cleared",
  CONFIRMED = "confirmed"
}
